// extracted by mini-css-extract-plugin
module.exports = {"checked":"_3q7f1z","unchecked":"mkboZV","text":"_3CbBzI"};